// first book
export const first = (images = {}, comment = {}) => {
  return `
  <h1 class="title">Getting started</h1>
<p></p>
<p>Welcome to hello ivy for <strong><span style="color: #3F40F2" type="color">teams</span></strong>! <span type="emoji"
    data="👋">👋</span></p>
<p></p>
<div type="block-color" style="background-color: #F8F8F8" class="color-block">This is a <strong><em>sample page</em></strong> that helps you to get started with hello ivy, it explains some of the basics. Feel free to play around with this page.</div>
<p></p>
<p></p>
<h2>Some of the basics</h2>
<ul data-type="todo_list" class="todo_list">
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>You're currently looking at a <strong>page</strong>, you can create a new page by using the "<span type="emoji" data="➕">➕</span>"<strong> </strong>icon in the sidebar on the left.</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>To organize the pages in the sidebar you can simply drag and drop them. To rename them, all you have to do is double-click on the title.</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>You can also nest pages for a better overview which leads to a more organized workspace.</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>All your work is <strong>saved instantly and automatically.</strong></p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>To go back to your <strong>Spaces page</strong> click on the arrow icon in the bottom left corner.</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Drag and drop spaces, pages, images, checkboxes, list items and more...</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Use <strong>CTRL + ?</strong> to easily switch between light and dark themes <span type="emoji" data="🌗">🌗</span>.</p>
  </li>
</ul>
<p></p>
<h2>What is hello ivy teams?</h2>
<p></p>
<blockquote>
  <p>Hello Ivy is a collaboration app for teams to focus and flourish. Work together in a smarter, more organized way. All your communication, projects, teams, tasks and documents in one place.</p>
</blockquote>
<p></p>
<p></p>
<h2><strong>To-do and task lists </strong><span type="emoji" data="✔️">✔️</span></h2>
<ul data-type="todo_list" class="todo_list">
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>This is a checkbox.</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>You can drag &amp; drop these by using the icon in front of the checkbox.</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Try it yourself.</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Type [] on a new line to quickly insert a new checkbox.</p>
  </li>
</ul>
<p></p>
<p></p>
<h2>Images</h2>
<p><span type="image" src="${images['first.jpg']?.url}"  id="${images['first.jpg']?.id}"
     style="width: 43%; position: relative; display: inline-block;
                line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="shadow-smooth"
    ischateditor="false" contenteditable="false"><span contenteditable="false"></span><span
      contenteditable="false"></span><span contenteditable="false"></span><img
      src="${images['first.jpg']?.url}"  id="${images['first.jpg']?.id}" style="width: 43%; position: relative; display: inline-block;
                line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="shadow-smooth"
      ischateditor="false"></span>
  <span type="image"
  src="${images['second.jpg']?.url}"  id="${images['second.jpg']?.id}" style="width: 45%; position: relative; display: inline-block;
      line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="shadow-smooth"
    contenteditable="false"><span contenteditable="false"></span><span contenteditable="false"></span><span
      contenteditable="false"></span><img
      src="${images['second.jpg']?.url}"  id="${images['second.jpg']?.id}" style="width: 45%; position: relative; display: inline-block;
      line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="shadow-smooth"></span></p>
<p><em>Double-click on images to zoom-in and view more options.</em></p>
<p></p>
<p></p>
<h3><strong>A last batch of helpful tips &amp; tricks:</strong></h3>
<ul data-type="todo_list" class="todo_list">
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Use the "<strong>@</strong>" symbol to create a link to other pages within hello ivy or to mention team members.</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Use "<strong>:</strong>" to insert emoji's <span type="emoji" data="😁">😁</span><span type="emoji" data="😎">😎</span><span type="emoji" data="💯">💯</span></p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>When you hover over the sidebar an icon appears, click on this to enable focus mode.</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Select text to <a target="_blank" rel="noopener noreferrer nofollow" href="https://helloivy.co/">create links</a>, change text color, highlight text and more...</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Press <strong>CTRL + 0</strong> for keyboard shortcuts.</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Use the share menu in the top right corner to share your pages.</p>
  </li>
</ul>
<p></p>
<p>There are a bunch more things to do, give hello ivy a try and see for yourself<span type="emoji" data="👀">👀</span>!</p>
<p></p>
<h3>Download the desktop apps</h3>
<p>Download the desktop apps for Windows and MAC here:</p>
<p><a target="_blank" rel="noopener noreferrer nofollow"
    href="https://helloivy.co/downloads">https://helloivy.co/downloads</a></p>
<p></p>
<h2>Work better, together.</h2>
<p><em>The hello ivy team.</em></p>
<p></p>
<p><span type="image" src="${images['third.svg']?.url}"  id="${images['third.svg']?.id}" style="width: 19%; position: relative; display: inline-block;
                line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class=""
    ischateditor="false" contenteditable="false"><span contenteditable="false"></span><span
      contenteditable="false"></span><span contenteditable="false"></span><img
      src="${images['third.svg']?.url}"  id="${images['third.svg']?.id}" style="width: 19%; position: relative; display: inline-block;
                line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class=""
      ischateditor="false"></span></p>
<p></p>
<p></p>
  `
}

export const second = () => {
  return `
  <h1 class="title">OKR &amp; Goals </h1>
<p>Getting to where we want to be. Track all your objectives in one place.</p>
<p></p>
<div type="block-color" style="background-color: #F8F8F8" class="color-block"><strong>What are OKRs? 
</strong>Objectives and Key Results (OKR) are a simple tool that helps a business to achieve its goals by building specific and measurable actions each quarter as well as communicating and monitoring progress towards these actions. Each department often has its own set of OKRs. </div>
<p></p>
<p></p>
<h2><span style="color: #3F40F2" type="color">OKRs - company wide</span></h2>
<p></p>
<p><strong>Period: </strong>Q3/2022</p>
<p><strong>Department: </strong>Company-wide</p>
<p><strong>OKRs created: </strong>12 june 2022</p>
<p></p>
<h3>OKR #1</h3>
<table class="">
  <tbody>
    <tr>
      <th colspan="1" rowspan="1" colwidth="416" style="">
        <p><strong>Objective</strong></p>
      </th>
      <th colspan="1" rowspan="1" colwidth="136" style="">
        <p><strong>Progress</strong></p>
      </th>
      <th colspan="1" rowspan="1" style="">
        <p><strong>Who?</strong></p>
      </th>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="">
        <p>Generate 250K in sales</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="">
        <p>70%</p>
      </td>
      <td colspan="1" rowspan="1" style="">
        <p><span style="color: #3F40F2" type="color">@JenniferAston</span></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="">
        <p><strong>Key results</strong></p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="">
        <p></p>
      </td>
      <td colspan="1" rowspan="1" style="">
        <p></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="">
        <p>Reduce platform load times with 35%</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="">
        <p>50%</p>
      </td>
      <td colspan="1" rowspan="1" style="">
        <p><span style="color: rgb(95, 95, 255)" type="color">@EricGrada</span></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="">
        <p>Reduce churn to less than 5% annually</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="">
        <p><mark data-color="rgb(39,205,145)" style="background-color: rgb(39,205,145)">100%</mark></p>
      </td>
      <td colspan="1" rowspan="1" style="">
        <p><span style="color: rgb(95, 95, 255)" type="color">@PeterFinch</span></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="">
        <p>Increase mobile conversion rates with 0.5%</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="">
        <p>50%</p>
      </td>
      <td colspan="1" rowspan="1" style="">
        <p><span style="color: rgb(95, 95, 255)" type="color">@LucasHuebl</span></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="">
        <p>Gain 4 new portfolio (<em>show-off</em>) customers</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="">
        <p>75%</p>
      </td>
      <td colspan="1" rowspan="1" style="">
        <p><span style="color: rgb(95, 95, 255)" type="color">@PeterFinch</span></p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<p></p>
<h3>OKR #2</h3>
<table class="0">
  <tbody>
    <tr>
      <th colspan="1" rowspan="1" colwidth="416" style="0">
        <p><strong>Objective</strong></p>
      </th>
      <th colspan="1" rowspan="1" colwidth="136" style="0">
        <p><strong>Progress</strong></p>
      </th>
      <th colspan="1" rowspan="1" style="0">
        <p><strong>Who?</strong></p>
      </th>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="0">
        <p>Launch new product successfully</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="0">
        <p>33%</p>
      </td>
      <td colspan="1" rowspan="1" style="0">
        <p><span style="color: rgb(95, 95, 255)" type="color">@JenniferAston</span></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="0">
        <p><strong>Key results</strong></p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="0">
        <p></p>
      </td>
      <td colspan="1" rowspan="1" style="0">
        <p></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="0">
        <p>Create a PR plan</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="0">
        <p>25%</p>
      </td>
      <td colspan="1" rowspan="1" style="0">
        <p><span style="color: rgb(95, 95, 255)" type="color">@GinaMiles</span></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="0">
        <p>Finalize product datasheets and sales forecast</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="0">
        <p>75%</p>
      </td>
      <td colspan="1" rowspan="1" style="0">
        <p><span style="color: rgb(95, 95, 255)" type="color">@LucasHuebl</span></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="0">
        <p>Test the product with a focus group before launch</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="0">
        <p>0%</p>
      </td>
      <td colspan="1" rowspan="1" style="0">
        <p><span style="color: rgb(95, 95, 255)" type="color">@LisaDrowes</span></p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<p></p>
<h2><span style="color: rgb(95, 95, 255)" type="color">OKRs - HR department</span></h2>
<p></p>
<p><strong>Period: </strong>Q3/2022</p>
<p><strong>Department: </strong>HR</p>
<p><strong>OKRs created: </strong>12 june 2022</p>
<p></p>
<table class="0">
  <tbody>
    <tr>
      <th colspan="1" rowspan="1" colwidth="416" style="0">
        <p><strong>Objective</strong></p>
      </th>
      <th colspan="1" rowspan="1" colwidth="136" style="0">
        <p><strong>Progress</strong></p>
      </th>
      <th colspan="1" rowspan="1" style="0">
        <p><strong>Who?</strong></p>
      </th>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="0">
        <p>Create an Exceptional Corporate Culture</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="0">
        <p>67%</p>
      </td>
      <td colspan="1" rowspan="1" style="0">
        <p><span style="color: rgb(95, 95, 255)" type="color">@MonaJones</span></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="0">
        <p><strong>Key results</strong></p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="0">
        <p></p>
      </td>
      <td colspan="1" rowspan="1" style="0">
        <p></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="0">
        <p>Get free gym membership for employees</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="0">
        <p>25%</p>
      </td>
      <td colspan="1" rowspan="1" style="0">
        <p><span style="color: rgb(95, 95, 255)" type="color">@KareemAbdel</span></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="0">
        <p>Score an 8.5+ with our employee survey</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="0">
        <p>75%</p>
      </td>
      <td colspan="1" rowspan="1" style="0">
        <p><span style="color: rgb(95, 95, 255)" type="color">@LucasHuebl</span></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="416" style="0">
        <p>Ensure every employee had a 1-on-1 meeting with <span style="color: rgb(95, 95, 255)" type="color">@MonaJones
          </span>with feedback from both sides</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="136" style="0">
        <p><mark data-color="rgb(39,205,145)" style="background-color: rgb(39,205,145)">100%</mark></p>
      </td>
      <td colspan="1" rowspan="1" style="0">
        <p><span style="color: rgb(95, 95, 255)" type="color">@JimDavids</span></p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
`
}

export const third = ({ bookId, project1, project2, project3 } = {}) => {
  return `
    <h1 class="title">Meeting notes</h1>
    <p>All our meeting recaps.</p>
    <p></p>
    <h4>Overview of most recent meetings:</h4>
    <p>Upcoming meeting: <em>no date yet</em></p>
    <p>15 September meeting (standup): <button class="mention" href="/space/${bookId}?page=${project3}" title="15 sept - standup">@15 sept - standup</button></p>
    <p>12 September meeting: <button class="mention" href="/space/${bookId}?page=${project2}" title="12 sept">@12 sept</button></p>
    <p>5 September meeting:<strong> </strong><button class="mention" href="/space/${bookId}?page=${project1}" title="5 sept">@5 sept</button></p>
    <p></p> 
  `
}

export const fourth = () => {
  return `
  <h1 class="title">Meeting notes </h1>
<p>Meeting notes of <u>September 5th</u>.</p>
<p></p>
<div type="block-color" style="background-color: #F8F8F8" class="color-block">💡 This meeting was delayed <strong>by 4 weeks</strong> due to COVID-19 issues.</div>
<p></p>
<h3><strong>Participants: </strong></h3>
<p><span style="color: #3F40F2" type="color">@JamesJohnsen</span>, <span style="color: #3F40F2"
    type="color">@BernardWilson</span>, <span style="color: #3F40F2" type="color">@AnitaOakley</span></p>
<p></p>
<h3><span type="emoji" data="🗒">🗒</span><strong> Meeting agenda:</strong></h3>
<ul>
  <li isevent="false" class="list-item select-none" id="0.42696387160855354">
    <div class="list-item-content">
      <p>Strategy for the 4th Quarter.</p>
      <ul>
        <li isevent="false" class="list-item select-none" id="0.42696387160855354">
          <div class="list-item-content">
            <p>Marketing budget should be decreased by 30% (low-season)</p>
          </div>
        </li>
        <li isevent="false" class="list-item select-none" id="0.42696387160855354">
          <div class="list-item-content">
            <p>Search for new office space </p>
          </div>
        </li>
        <li isevent="false" class="list-item select-none" id="0.42696387160855354">
          <div class="list-item-content">
            <p>The new CFO. What are we looking for?</p>
          </div>
        </li>
        <li isevent="false" class="list-item select-none" id="0.42696387160855354">
          <div class="list-item-content">
            <p>Q3 revenue review</p>
          </div>
        </li>
      </ul>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.594968366568998">
    <div class="list-item-content">
      <p>New employee perks</p>
    </div>
  </li>
</ul>
<p></p>
<h3><span type="emoji" data="✔️">✔️</span> Action Items:</h3>
<ul data-type="todo_list" class="todo_list">
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Calculate new marketing budget <span style="color: rgb(95, 95, 255)" type="color">@AnitaOakley</span></p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Write CFO job description <span style="color: rgb(95, 95, 255)" type="color">@BernardWilson</span></p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p><span style="color: rgb(95, 95, 255)" type="color">@JamesJohnsen, </span>go to office viewing instead of <span
        style="color: #3F40F2" type="color">@ErinHunt </span>on monday 13:45PM.</p>
  </li>
</ul>
<p></p>
<h3>Not resolved:</h3>
<ul>
  <li isevent="false" class="list-item select-none" id="0.7679096264229792">
    <div class="list-item-content">
      <p>The Q3 revenue review has been moved to next week's meeting. </p>
    </div>
  </li>
</ul>
<p></p>
<p></p>
<p></p>
<p></p>
  `
}

export const fifth = () => {
  return `
  <h1 class="title">Meeting notes </h1>
<p>Meeting notes of <u>September 12th</u>.</p>
<p></p>
<div type="block-color" style="background-color: #F8F8F8" class="color-block">💡 Meeting was held via Zoom, <span
    style="color: #3F40F2" type="color">@KimLangley</span> did not attend due to illness.</div>
<p></p>
<h3><strong>Participants: </strong></h3>
<p><span style="color: rgb(95, 95, 255)" type="color">@JamesJohnsen</span>, <span style="color: rgb(95, 95, 255)"
    type="color">@FinnMusk</span>,<span style="color: rgb(95, 95, 255)" type="color"> @BernardWilson</span>, <span
    style="color: rgb(95, 95, 255)" type="color">@AnitaOakley</span>, <span style="color: rgb(95, 95, 255)"
    type="color">@PatrickCardoso</span></p>
<p></p>
<h3><span type="emoji" data="🗒">🗒</span><strong> Meeting agenda:</strong></h3>
<ul>
  <li isevent="false" class="list-item select-none" id="0.182573569677275">
    <div class="list-item-content">
      <p>Q3 Revenue review</p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.182573569677275">
    <div class="list-item-content">
      <p>Yearly company event to Mallorca</p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.182573569677275">
    <div class="list-item-content">
      <p>Long-term growth strategy</p>
    </div>
  </li>
</ul>
<p></p>
<h3><span type="emoji" data="✔️">✔️</span> Action Items:</h3>
<ul data-type="todo_list" class="todo_list">
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Hire a new office manager <span style="color: rgb(95, 95, 255)" type="color">@AnitaOakley</span></p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Book Mallorca trip for all 42 team members <span style="color: rgb(95, 95, 255)"
        type="color">@PatrickCardoso</span></p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Create list with items to increase revenue for Q4 <span style="color: rgb(95, 95, 255)"
        type="color">@FinnMusk</span></p>
  </li>
</ul>
<p></p>
<h3>Not resolved:</h3>
<p><em><span style="color: rgb(221,221,221)" type="color">Everything resolved</span></em></p>
<p></p>
<p></p>
<p></p>
<p></p>
<p></p>
  `
}

export const sixth = () => {
  return `
  <h1 class="title">Standup of 15 sept</h1>
<p>A quick update.</p>
<p></p>
<hr>
<p></p>
<h3><strong>Participants: </strong></h3>
<ul>
  <li isevent="false" class="list-item select-none" id="0.31336953356338815">
    <div class="list-item-content">
      <p>The entire sales department</p>
    </div>
  </li>
</ul>
<p></p>
<h3>What did we do last week?</h3>
<ul>
  <li isevent="false" class="list-item select-none" id="0.31336953356338815">
    <div class="list-item-content">
      <p>We broke our sales record by 10% which is great! <span type="emoji" data="🥳">🥳</span></p>
    </div>
  </li>
</ul>
<p></p>
<h3>What are we doing coming week?</h3>
<ul>
  <li isevent="false" class="list-item select-none" id="0.31336953356338815">
    <div class="list-item-content">
      <p>Have a lunch at Mcgees to celebrate.</p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.31336953356338815">
    <div class="list-item-content">
      <p>Discuss goals for coming month.</p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.31336953356338815">
    <div class="list-item-content">
      <p>Switch email client.</p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.31336953356338815">
    <div class="list-item-content">
      <p>Change lead form on website with marketing dept.</p>
    </div>
  </li>
</ul>
<p></p>
<h3>Any blockers?</h3>
<ul>
  <li isevent="false" class="list-item select-none" id="0.31336953356338815">
    <div class="list-item-content">
      <p>None so far.</p>
    </div>
  </li>
</ul>
<p></p>
<h3><span type="emoji" data="✔️">✔️</span> Action Items:</h3>
<ul data-type="todo_list" class="todo_list">
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Find alternative email client.</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Write down goals in hello ivy.</p>
  </li>
</ul>
<p></p>
  `
}

// second book
export const seventh = () => {
  return `
  <h1 class="title">Welcome to marketing!</h1>
<p></p>
<p>This space is the home of the marketing team. We spend 70% of our time working and communicating in hello ivy. By doing so we were able to have 50% less meetings and become a more productive team overall! We are much more organized than before.</p>
<p></p>
<p>Here's an overview of the current marketing team:</p>
<p></p>
<h3><strong>Manager</strong></h3>
<p><span style="color: #3F40F2" type="color">Michelle Davin (michelle@acme.com)</span></p>
<p></p>
<h3><strong>Team</strong></h3>
<p><em>Demand generation</em></p>
<p><span style="color: #3F40F2" type="color">Hannah List (hannah@acme.com)</span></p>
<p><span style="color: #3F40F2" type="color">Michael Baldwin (michael@acme.com)</span></p>
<p><em>Social Media</em></p>
<p><span style="color: #3F40F2" type="color">Miljouska Kriveski (miljouska@acme.com)</span></p>
<p><em>Content Marketing</em></p>
<p><span style="color: #3F40F2" type="color">Jeff Miller (jeff@acme.com)</span></p>
<p><span style="color: #3F40F2" type="color">Lisa Clover (lisa@acme.com)</span></p>
<p><em>Intern</em></p>
<p><span style="color: rgb(95, 95, 255)" type="color">Charles Iverson (charles@acme.com)</span></p>
<p></p>
<h3>Page management</h3>
<ul>
  <li isevent="false" class="list-item select-none" id="0.818164466833903">
    <div class="list-item-content">
      <p>Please keep new pages to a minimum and once a project or page has been fully completed: <strong>archive it </strong><em>(don't delete)</em>. </p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.818164466833903">
    <div class="list-item-content">
      <p>Page names should have a clear description.</p>
    </div>
  </li>
</ul>
<p></p>
<p></p>
<p></p>
  `
}

export const eighth = () => {
  return `
  <h1 class="title">Onboarding</h1>
<p>Onboarding new marketing team members</p>
<p></p>
<p></p>
<h2>Day 1</h2>
<hr>
<ul>
  <li isevent="false" class="list-item select-none" id="0.8525907889398876">
    <div class="list-item-content">
      <p>Meet all team members in the morning</p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.8525907889398876">
    <div class="list-item-content">
      <p>Michelle explains how the marketing dept. operates</p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.8525907889398876">
    <div class="list-item-content">
      <p>Team lunch</p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.8525907889398876">
    <div class="list-item-content">
      <p>First look at objectives and showing desk</p>
    </div>
  </li>
</ul>
<p></p>
<p></p>
<h2>Day 2 </h2>
<hr>
<ul>
  <li isevent="false" class="list-item select-none" id="0.8525907889398876">
    <div class="list-item-content">
      <p>Meeting the rest of the company</p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.8525907889398876">
    <div class="list-item-content">
      <p>Introduction to all the tools we use</p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.8525907889398876">
    <div class="list-item-content">
      <p>Shareholder program explanation</p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.8525907889398876">
    <div class="list-item-content">
      <p>Set up email + email signature </p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.8525907889398876">
    <div class="list-item-content">
      <p>Get work phone</p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.8525907889398876">
    <div class="list-item-content">
      <p>Obtain login information from IT</p>
    </div>
  </li>
</ul>
<p></p>
<p></p>
<h2>Day 3 </h2>
<hr>
<ul>
  <li isevent="false" class="list-item select-none" id="0.8525907889398876">
    <div class="list-item-content">
      <p>Register for benefits</p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.8525907889398876">
    <div class="list-item-content">
      <p>Complete hiring paperwork</p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.8525907889398876">
    <div class="list-item-content">
      <p>Start work</p>
    </div>
  </li>
</ul>
<p></p>
<p></p>
<h2>Day 4</h2>
<hr>
<ul>
  <li isevent="false" class="list-item select-none" id="0.8525907889398876">
    <div class="list-item-content">
      <p>Onboarding complete</p>
    </div>
  </li>
</ul>
<p></p>
<p></p>
<p><br></p>
<p></p>
<p></p>
<p></p>
  `
}

export const ninth = ({ bookId, projectId } = {}) => {
  return `
  <h1 class="title">Newsletters</h1>
<p>Spreading the word.</p>
<p></p>
<p><strong>All marketing newsletters:</strong></p>
<p><button class="mention" href="/space/${bookId}?page=${projectId}" title="Welcome email">@Welcome email</button></p>
<p></p>
  `
}

export const tenth = (image = {}) => {
  return `
  <h1 class="title">Welcome email</h1>
<p></p>
<p><strong>Send time: </strong>1 hour after signup</p>
<p></p>
<p><strong>Subject:</strong> Welcome to hello ivy. <span type="emoji" data="👋">👋</span></p>
<p><strong>From:</strong> Alex from hello ivy.</p>
<p></p>
<hr>
<p></p>
<h1>[LOGO]</h1>
<p></p>
<p>Hi {first name},</p>
<p></p>
<p>Today is a good day... Why?</p>
<p></p>
<p>Because you've taken the first step towards becoming a more <em>organized </em>and <em>productive </em>person. <span
    type="emoji" data="✍">✍</span><span type="emoji" data="📁">📁</span><span type="emoji" data="💯">💯</span></p>
<p></p>
<p>From this point onwards all your data is within easy reach and follows you wherever you go. Notes, tasks, documents, plans, books... whatever it is that you like to use hello ivy for, from now on it's <strong>all-in-one place</strong>.
</p>
<p></p>
<p>[<strong>Go to Hello Ivy</strong> button] <em>this button leads to the app</em></p>
<p></p>
<p><strong>Let's create a project together</strong></p>
<p>Starting with a new app can be overwhelming at times, but no worry we're here to help you. The more you use the app, the more you start seeing its value and what it is capable off. Just give it some time.</p>
<p></p>
<p>The best way to get the hang of hello ivy is to create a couple of projects and simply start writing. Whatever you want to do within the app, it almost always starts with creating a project:</p>
<p></p>
<p><span type="image" src="${image.url}"  id="${image.id}" style="width: 100%; position: relative; display: inline-block;
  line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="shadow-smooth"
    contenteditable="false"><span contenteditable="false"></span><span contenteditable="false"></span><span
      contenteditable="false"></span><img
      src="${image.url}"  id="${image.id}" style="width: 100%; position: relative; display: inline-block;
  line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="shadow-smooth"></span></p>
<p></p>
<p><em>With the </em><strong><em>+ icon </em></strong><em>in the sidebar</em><strong><em> </em></strong><em>you can create a new project.</em></p>
<p></p>
<p>[<strong>Create your first project </strong>button] <em>this button leads to the app</em></p>
<p></p>
<p><strong>Take your time, hello ivy is free forever.</strong></p>
<p><em>hello ivy</em> is 100% free to use. The FREE plan works great for most users and has almost all of the features the paid version has. The biggest difference is that the free version has <u>limited</u> storage space, projects and notebooks.</p>
<p></p>
<p>If you want <strong>unlimited</strong> notebooks, projects and storage space we recommend you to upgrade to the PRO plan for just $4 a month. You won't regret it and you can cancel whenever you want.</p>
<p></p>
<p>[<strong>Yes, upgrade me to PRO</strong> button] <em>this button upgrades the user to PRO</em></p>
<p></p>
<p>Over the next couple of weeks you’ll receive some more emails from us that help you to get started! We hope you will find these useful.</p>
<p></p>
<p>Any questions? Let us know at hello@helloivy.co</p>
<p></p>
<p>Have a great day.</p>
<p>Alex</p>
<p></p>
<p><em>Go to hello ivy link (not button)</em></p>
<p></p>
  `
}

export const eleventh = (images = {}) => {
  return `
  <h1 class="title">Public relations</h1>
<p>Getting our brand out there.</p>
<p></p>
<h3>PR agencys we work with</h3>
<ul>
  <li isevent="false" class="list-item select-none" id="0.5350601949423759">
    <div class="list-item-content">
      <p>Udeno - <a target="_blank" rel="noopener noreferrer nofollow" href="https://udeno.co">udeno.co</a></p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.5350601949423759">
    <div class="list-item-content">
      <p>Cover Coverage - <a target="_blank" rel="noopener noreferrer nofollow"
          href="https://ccoverage.co">ccoverage.co</a></p>
    </div>
  </li>
  <li isevent="false" class="list-item select-none" id="0.5350601949423759">
    <div class="list-item-content">
      <p>Origami Roads (email only) - <a target="_blank" rel="noopener noreferrer nofollow"
          href="https://origamiroads.co">origamiroads.co</a></p>
    </div>
  </li>
</ul>
<p></p>
<h2>The plan</h2>
<p>The focus for the coming quarter is not on paid ads but on PR. We need to get more media exposure from the bigger websites/brands (inlcuding backlinks for SEO). Think company's like Forbes, Times, Techcrunch, The Washington Post, etc. We hired all three above mentioned PR agencies to help us with this. We'll be having a meeting with them <strong><u>next week Friday (the 14th)</u> </strong>but until that time we should prepare for these meetings and gather as much relevant marketing material as possible. <span style="color: rgb(95, 95, 255)" type="color">@JeffMiller </span>can you have a look at this?</p>
<p></p>
<h2>Media</h2>
<p></p>
<p>The logo:</p>
<p></p>
<p><span type="image" src="${images['first.svg']?.url}"  id="${images['first.svg']?.id}" style="width: 19%; position: relative; display: inline-block;
  line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="" ischateditor="false"
    contenteditable="false"><span contenteditable="false"></span><span contenteditable="false"></span><span
      contenteditable="false"></span><img
      src="${images['first.svg']?.url}"  id="${images['first.svg']?.id}" style="width: 19%; position: relative; display: inline-block;
  line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="" ischateditor="false"></span>
</p>
<p></p>
<p> <span type="image" src="${images['second.svg']?.url}"  id="${images['second.svg']?.id}" style="width: 35%; position: relative; display: inline-block;
  line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="" ischateditor="false"
    contenteditable="false"><span contenteditable="false"></span><span contenteditable="false"></span><span
      contenteditable="false"></span><img
      src="${images['second.svg']?.url}"  id="${images['second.svg']?.id}" style="width: 35%; position: relative; display: inline-block;
  line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="" ischateditor="false"></span>
</p>
<p></p>
<p></p>
<p><span type="image" src="${images['third.png']?.url}"  id="${images['third.png']?.id}" style="width: 50%; position: relative; display: inline-block;
  line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="" ischateditor="false"
    contenteditable="false"><span contenteditable="false"></span><span contenteditable="false"></span><span
      contenteditable="false"></span><img
      src="${images['third.png']?.url}"  id="${images['third.png']?.id}" style="width: 50%; position: relative; display: inline-block;
  line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="" ischateditor="false"></span>
</p>
<p></p>
<p></p>
<p></p>
<p></p>
<p></p>
<p></p>
<p></p>
  `
}

export const twelfth = (images = {}) => {
  return `
  <h1 class="title">Concept ads</h1>
<p>Creating our new advertisements.</p>
<p></p>
<h3>Which version do you guys prefer?</h3>
<p></p>
<p><span type="image" src="${images['first.svg']?.url}"  id="${images['first.svg']?.id}" style="width: 72%; position: relative; display: inline-block;
  line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="" imagecomment="6602"
    ischateditor="false" contenteditable="false"><span contenteditable="false"></span><span
      contenteditable="false"></span><span contenteditable="false"></span><img
      src="${images['first.svg']?.url}"  id="${images['first.svg']?.id}" style="width: 72%; position: relative; display: inline-block;
  line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="" imagecomment="6602"
      ischateditor="false"></span></p>
<p></p>
<p></p>
<p><span type="image" src="${images['second.svg']?.url}"  id="${images['second.svg']?.id}" style="width: 72%; position: relative; display: inline-block;
  line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="shadow-smooth"
    ischateditor="false" contenteditable="false"><span contenteditable="false"></span><span
      contenteditable="false"></span><span contenteditable="false"></span><img
      src="${images['second.svg']?.url}"  id="${images['second.svg']?.id}" style="width: 72%; position: relative; display: inline-block;
  line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class="shadow-smooth"
      ischateditor="false"></span></p>
<p></p>
<p></p>
<p></p>
<p></p>
<p></p>
<p></p>
<p></p>
  `
}

// third book
export const thirteenth = () => {
  return `
  <h1 class="title">Roadmap</h1>
<p>Getting the new website live!</p>
<p></p>
<p></p>
<table class="">
  <tbody>
    <tr>
      <th colspan="1" rowspan="1" colwidth="189" style="">
        <h3><strong> Date</strong></h3>
      </th>
      <th colspan="1" rowspan="1" colwidth="310" style="">
        <h3><strong> Done</strong></h3>
        <p></p>
      </th>
      <th colspan="1" rowspan="1" colwidth="177" style="">
        <h3><strong> Responsible</strong></h3>
      </th>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="189" style="background-color: rgb(180,238,57)">
        <p><strong>21-9</strong> Tuesday</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="310" style="background-color: rgb(180,238,57)">
        <p>Start <strong>website redesign</strong> project</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="177" style="background-color: rgb(180,238,57)">
        <p><span style="color: #3F40F2" type="color">@jamesgafferty / </span><span style="color: rgb(95, 95, 255)"
            type="color">@MonicaCleef</span></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="189" style="">
        <p><strong><span style="color: rgb(71, 71, 71)" type="color">24-9</span><span style="color: rgb(71,71,71)"
              type="color"> </span></strong><span style="color: rgb(71,71,71)" type="color">Friday</span></p>
      </td>
      <td colspan="1" rowspan="1" colwidth="310" style="">
        <p>Finish all copy and visuals</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="177" style="">
        <p><span style="color: rgb(95, 95, 255)" type="color">@jamesgafferty</span></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="189" style="">
        <p><strong><span style="color: rgb(71,71,71)" type="color">01-10 </span></strong><span
            style="color: rgb(71,71,71)" type="color">Friday</span></p>
      </td>
      <td colspan="1" rowspan="1" colwidth="310" style="">
        <p>Get style approved by executive team</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="177" style="">
        <p><span style="color: rgb(95, 95, 255)" type="color">@EvelineHarling</span></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="189" style="">
        <p><strong><span style="color: rgb(71,71,71)" type="color">12-10 </span></strong><span
            style="color: rgb(71,71,71)" type="color">Tuesday</span></p>
      </td>
      <td colspan="1" rowspan="1" colwidth="310" style="">
        <p>Finish version 1.0 for testing</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="177" style="">
        <p><span style="color: rgb(95, 95, 255)" type="color">@jamesgafferty</span></p>
      </td>
    </tr>
    <tr>
      <td colspan="1" rowspan="1" colwidth="189" style="">
        <p><strong><span style="color: rgb(71,71,71)" type="color">21-10 </span></strong><span
            style="color: rgb(71,71,71)" type="color">Thursday</span></p>
      </td>
      <td colspan="1" rowspan="1" colwidth="310" style="">
        <p>Finish <strong>website redesign</strong> project</p>
      </td>
      <td colspan="1" rowspan="1" colwidth="177" style="">
        <p><span style="color: rgb(95, 95, 255)" type="color">@MonicaCleef</span></p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<p></p>
<h2>Important snippet </h2>
<p>We should NOT forget to add this snippet to the &lt;header&gt; of each page. This is our analytics snippet that will track all website stats.</p>
<p></p>
<pre><code>&lt;script&gt;
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-423543656-1', { 'optimize_id': 'GTM-N7%sg323'});
  gtag('config', 'AW-43242344');
&lt;/script&gt;</code></pre>
<p></p>
  `
}

export const fourteenth = () => {
  return `
  <h1 class="title">To-dos </h1>
<p>Getting our new website live asap.</p>
<p></p>
<p><strong>Week 1:</strong></p>
<ul data-type="todo_list" class="todo_list">
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Get all visuals done (created by <span style="color: #3F40F2" type="color">Beesee </span>design agency)</p>
    <ul data-type="todo_list" class="todo_list">
      <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
        <p>Homepage visuals</p>
      </li>
      <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
        <p>Support page visuals</p>
      </li>
      <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
        <p>About us page visuals</p>
      </li>
    </ul>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Write copy for the homepage/introduction</p>
  </li>
</ul>
<p></p>
<p><strong>Week 2:</strong></p>
<ul data-type="todo_list" class="todo_list">
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Communicate changes with programmers</p>
    <ul data-type="todo_list" class="todo_list">
      <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
        <p>Discuss estimates</p>
      </li>
    </ul>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Send back visuals for revision (if necessary) </p>
  </li>
</ul>
<p></p>
<p><strong>Week 4:</strong></p>
<ul data-type="todo_list" class="todo_list">
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Present website v1.0 to Executive team</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Implement feedback Exectuive team</p>
  </li>
</ul>
<p></p>
<p><strong>Week 4:</strong></p>
<ul data-type="todo_list" class="todo_list">
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>Launch website</p>
  </li>
</ul>
<p></p>
<p><strong>Week 5:</strong></p>
<ul data-type="todo_list" class="todo_list">
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>A/B test lead form</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>A/B test CTA color</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>A/B test Homepage hero title</p>
  </li>
</ul>
<p></p>
<p></p>
<p></p>
  `
}

export const headquartersFirst = () => {
  return `
  <h1 class="title">Mission &amp; vision</h1>
<p></p>
<h2><span type="emoji" data="🚀">🚀</span> Our mission statement </h2>
<p></p>
<blockquote>
<p>“To empower every team on the planet to achieve more.”</p>
</blockquote>
<p></p>
<p></p>
<h2><span type="emoji" data="🕶">🕶</span> Our vision </h2>
<p></p>
<blockquote>
  <p>"To let you fill in your own vision."</p>
</blockquote>
<p></p>
<p></p>
<h2><span type="emoji" data="✔️">✔️</span> Company goals </h2>
<ul data-type="todo_list" class="todo_list">
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>To achieve greatness.</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>To become a unicorn with 2 horns.</p>
  </li>
  <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
    <p>To never go bankrupt.</p>
  </li>
</ul>
<p></p>
<p></p>
<p></p>
  `
}
